// Maps the read-only client-portal payload into the formData shape that
// OverviewClosingPath consumes. The portal has no agent email log, so log-derived
// milestone dates are not available here (callers pass logEntries={[]}).
//
// Spreading `transaction` wholesale is safe ONLY because the server already passed
// it through buildPortalTransactionView's strict field whitelist
// (functions/portalView.js). If that whitelist widens, anything added flows straight
// into the client formData unfiltered — keep the whitelist the gate.

export function buildPortalClosingPathFormData(portalData) {
    const transaction = portalData?.transaction || {};
    return {
        ...transaction,
        completedMilestones: portalData?.completedMilestones || {}
    };
}
